import { pr } from '@upgrade/react-components/Spacing/core';
import styled from 'styled-components';
import Image from '../common/Image';

export const StyledLogo = styled(Image)`
  max-width: 7rem;
  max-height: 5rem;
  object-fit: contain;

  @media (min-width: ${props => props.theme.mediaSm}) {
    max-width: 10rem;
    max-height: 7rem;
    margin: 2px 0;
  }
`;

export const StyledPartnerLogoExperiment = styled.div`
  position: absolute;
  left: 0;
  top: -24px;
  width: 100%;
  display: flex;
  justify-content: end;
  max-width: ${props => props.theme.mediaXl};
  ${pr('md')}

  @media (min-width: ${props => props.theme.mediaSm}) {
    ${pr('xl')}
  }
`;

export const StyledImg = styled(Image)`
  width: ${({ width }) => width * 0.9}px;
  height: ${({ height }) => height * 0.9}px;

  @media (min-width: ${props => props.theme.mediaSm}) {
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
  }
`;
